import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import Logo from "@/components/Logo";

const LINKS = [
    { href: "#opportunite", label: "Opportunité" },
    { href: "#programme", label: "Programme" },
    { href: "#catalogue", label: "Catalogue" },
    { href: "#revenus", label: "Revenus" },
    { href: "#rejoindre", label: "Rejoindre" },
];

export default function Navbar({ onJoin }) {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 40);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const darkMode = !scrolled; // hero is dark — navbar starts transparent on dark
    return (
        <header
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
                scrolled
                    ? "bg-white/85 backdrop-blur-xl border-b border-cap-border"
                    : "bg-transparent"
            }`}
            data-testid="navbar"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex items-center justify-between h-16 sm:h-[72px]">
                    <a
                        href="#top"
                        className="flex items-center"
                        data-testid="navbar-logo-link"
                    >
                        <Logo variant={darkMode ? "white" : "ink"} />
                    </a>

                    <nav className="hidden lg:flex items-center gap-8">
                        {LINKS.map((l) => (
                            <a
                                key={l.href}
                                href={l.href}
                                data-testid={`nav-link-${l.href.replace("#", "")}`}
                                className={`text-[14.5px] font-medium transition-colors ${
                                    darkMode
                                        ? "text-white/80 hover:text-white"
                                        : "text-cap-text/80 hover:text-cap-violet"
                                }`}
                            >
                                {l.label}
                            </a>
                        ))}
                    </nav>

                    <div className="flex items-center gap-2">
                        <button
                            onClick={onJoin}
                            className="hidden sm:inline-flex btn-gold px-5 py-2.5 rounded-full text-sm"
                            data-testid="navbar-cta-devenir-partenaire"
                        >
                            Devenir partenaire
                        </button>
                        <button
                            className={`lg:hidden p-2 ${
                                darkMode ? "text-white" : "text-cap-ink"
                            }`}
                            onClick={() => setOpen((o) => !o)}
                            aria-label="Menu"
                            data-testid="navbar-mobile-menu-toggle"
                        >
                            {open ? <X size={22} /> : <Menu size={22} />}
                        </button>
                    </div>
                </div>
            </div>

            {open && (
                <div
                    className="lg:hidden bg-white border-t border-cap-border"
                    data-testid="navbar-mobile-menu"
                >
                    <div className="px-6 py-5 flex flex-col gap-4">
                        {LINKS.map((l) => (
                            <a
                                key={l.href}
                                href={l.href}
                                onClick={() => setOpen(false)}
                                className="text-[15px] font-medium text-cap-ink hover:text-cap-violet"
                                data-testid={`mobile-nav-link-${l.href.replace("#", "")}`}
                            >
                                {l.label}
                            </a>
                        ))}
                        <button
                            onClick={() => {
                                setOpen(false);
                                onJoin();
                            }}
                            className="btn-gold py-3 rounded-full text-sm mt-2"
                            data-testid="navbar-mobile-cta"
                        >
                            Devenir partenaire
                        </button>
                    </div>
                </div>
            )}
        </header>
    );
}
